import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useSlugResolution} from '../context/SlugResolutionContext';
import {useRoomSlugResolution} from '../context/RoomSlugResolutionContext';
import {normalizeRedirectUri, REDIRECT_PARAM, setStoredRedirectUri} from '../util/redirect';

export const useCaptureRedirectUri = (): void => {
    const {search} = useLocation();
    const slugResolution = useSlugResolution();
    const roomSlugResolution = useRoomSlugResolution();
    const presetUri =
        slugResolution?.params[REDIRECT_PARAM] ?? roomSlugResolution?.params.find((param) => param.key === REDIRECT_PARAM)?.value;
    const redirectUri = new URLSearchParams(search).get(REDIRECT_PARAM) ?? presetUri;

    useEffect(() => {
        setStoredRedirectUri(redirectUri ? normalizeRedirectUri(redirectUri) : null);
    }, [redirectUri]);
};
